/*
 * Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {FormControl, ValidationErrors} from '@angular/forms';

export class WhiteSpaceInputValidator {
  /**
   * Validator function that validates if input is just whitespace
   */
  static noWhitespaceValidator(control: FormControl): ValidationErrors {
    const isWhitespace = (control && control.value && control.value.toString() || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { whitespace: true };
  }
}
